import { create } from "zustand";
import { api, ApiError } from "../lib/api";

interface User {
  id: string;
  email: string;
  name: string;
  role: "admin" | "user";
  /** Établissements liés (interface client) avec le rôle par établissement. */
  tenants: Array<{ tenantId: string; name: string; role: "tenant_owner" | "tenant_staff" | "tenant_callback_only" }>;
}

interface AuthState {
  user: User | null;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: true,
  login: async (email, password) => {
    const u = await api<User>("/api/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
    set({ user: u });
  },
  logout: async () => {
    try {
      await api("/api/auth/logout", { method: "POST" });
    } catch {}
    set({ user: null });
  },
  refresh: async () => {
    try {
      const u = await api<User>("/api/auth/me");
      set({ user: u, loading: false });
    } catch (e) {
      if (!(e instanceof ApiError) || e.status !== 401) {
        console.error("auth refresh failed", e);
      }
      set({ user: null, loading: false });
    }
  },
}));
